<template>
    <div :class="[`material-card w-100`, { selected: selected, fade: fade }]">
    <div class="card-content">
      <div class="text-section w-100">
        <div class="title-row w-100 v-center">
          <slot name="icon-slot"></slot>
          <div class="title elipsis-text" v-overflow-tooltip>{{ title }}</div>
        </div>
        <div  class="pt-3 elipsis-text material-id" v-if="materialId"
                  v-overflow-tooltip>Material-Id: {{ materialId }}</div>
        <slot name="subtitle"></slot>
      </div>
      <div class="v-center gap-1">
        <slot name="actions"></slot>
          <div v-if="count != null" class="count-badge center">
        {{ count }}
      </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'settingBar',
  props: {
    title: {
      type: String,
      default: ' '
    },
    subscript: {
      type: String,
      default: ''
    },
    count: {
      type: Number,
      default: null
    },
    action: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    fade: {
      type: Boolean,
      default: false
    },
    materialId: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.material-card {
  border-radius: 2px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  width: 100%;
  //   max-width: 500px;
}
.count-badge {
  background:  rgba(247, 246, 246, 0.613);;
  color: black;
  font-weight: 400;
  padding: 4px 5px;
  border-radius: 3px;
  font-size: var(--text-xs1);
  min-width: 25px;
  text-align: center;
  border: 1px solid #d4d5d9;
}
.material-card:hover:not(.selected) {
  background-color: #f1f3f5;
  transition: background 0.2s ease-in-out;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
}

/* disable if parent is active */
.router-link-active .material-card:hover {
  background-color: unset;
  box-shadow: none;
}
.material-card:hover .actions {
  display: block;
}
.router-link-active {
  .material-card {
    background: linear-gradient(
      90deg,
      rgba(233, 206, 140, 0.37) 0%,
      rgba(233, 206, 140, 0.2) 27%,
      rgba(255, 255, 255, 1) 77%
    );
    border-left: 4px solid var(--brand-color);
  }
  .count-badge {
    background: var(--brand-color);
    color: #fff;
    font-weight: 500;
  }
}
.selected {
  background: linear-gradient(
    90deg,
    rgba(233, 207, 140, 0.167) 0%,
    rgba(233, 207, 140, 0.128) 27%,
    rgba(255, 255, 255, 1) 77%
  );
  border-left: 4px solid var(--brand-color);
  .count-badge {
    background: var(--brand-color);
    color: #fff;
    font-weight: 500;
  }
}
.card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 8px 8px;
  min-height: 40px;
}

.text-section {
  text-align: left;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
}

.title-row {
  min-width: 0;
  gap: 7px;
}

.title {
  margin: 0;
  font-size: var(--text-s);
  color: #1a1a1a;
  flex: 1;
  min-width: 0;
}

.fade {
  background-color: #d3d3d34f;
  opacity: 0.7;
}
.customlist-bar {
  .title{
      font-weight:400;
  }
}
.material-id {
  padding: 3px 0;
  margin-top: 2px;
  align-items: center;
  font-size: var(--text-s);
  color: #8c8989;
}
</style>
